(function(){
  // Avoid duplicates
  if (window.__scrollToTopInjected) return; 
  window.__scrollToTopInjected = true;

  function injectStyles(){
    var css = '\n.scroll-to-top{position:fixed;bottom:30px;right:30px;width:56px;height:56px;border-radius:50%;border:none;background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;box-shadow:0 12px 28px rgba(102,126,234,.35);cursor:pointer;display:grid;place-items:center;font-size:20px;z-index:9999;opacity:0;visibility:hidden;transition:all .25s ease;transform:translateY(20px)}\n.scroll-to-top.visible{opacity:1;visibility:visible;transform:translateY(0)}\n.scroll-to-top:hover{transform:translateY(-6px);box-shadow:0 14px 32px rgba(102,126,234,.5)}\n.scroll-to-top:active{transform:translateY(-2px)}\n@media (max-width:768px){.scroll-to-top{bottom:90px;right:12px;width:50px;height:50px}}\n';
    var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
  }

  function injectButton(){
    if (document.getElementById('scrollToTop')) return;
    var btn = document.createElement('button');
    btn.id = 'scrollToTop';
    btn.className = 'scroll-to-top';
    btn.setAttribute('aria-label','Volver arriba');
    btn.replaceChildren();
    var icon = document.createElement('i');
    icon.className = 'fas fa-arrow-up';
    btn.appendChild(icon);
    document.body.appendChild(btn);
    return btn;
  }

  function setup(){
    injectStyles();
    var btn = injectButton();
    if (!btn) btn = document.getElementById('scrollToTop');
    if (!btn) return;
    var _scrollTicking = false;
    function onScroll(){
      if (_scrollTicking) return;
      _scrollTicking = true;
      requestAnimationFrame(function(){
        var show = window.scrollY > 400;
        btn.classList.toggle('visible', show);
        _scrollTicking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function(e){ e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
